import { dpr } from 'Utils/dpr';
import { getNewDimensionsWithAspectRatio } from 'Utils/getNewDimensionsWithAspectRatio';

import { IImageSectionModel } from 'Types/Litium';

const SocialSection = ({
    socialSection,
}: {
    socialSection: IImageSectionModel[];
}) => (
    <ul className="flex w-full flex-wrap justify-center gap-4 px-4.5 pb-4 lg:mx-auto lg:px-0 lg:pb-4">
        {socialSection.map((item, index) => (
            <li key={index}>
                <a
                    href={item.linkUrl}
                    target="_blank"
                    className="font-montserrat text-sm"
                    rel="noreferrer"
                >
                    <img
                        className="h-8 w-8 max-w-max"
                        height={item.image.height > 0 ? 32 : undefined}
                        width={
                            item.image.width > 0
                                ? getNewDimensionsWithAspectRatio(
                                      item.image.width,
                                      item.image.height,
                                      32,
                                      'width'
                                  )
                                : undefined
                        }
                        src={`${item.image.src}?format=webp&height=32`}
                        srcSet={dpr(`${item.image.src}?format=webp&height=32`)}
                        alt={item.image.altText}
                    />
                </a>
            </li>
        ))}
    </ul>
);

export default SocialSection;
